module.exports = __webpack_public_path__ + "static/media/hardy-tm-change-demo1.5c085921.jpg";